if (!customElements.get('certificate-slider')) {
  customElements.define('certificate-slider', class CertificateSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-certificate-track]');
      this.slides = [...this.querySelectorAll('.certificate-slider__slide')];
      this.dots = this.querySelector('[data-certificate-dots]');
      this.lightbox = this.querySelector('[data-certificate-lightbox]');
      if (!this.track || !this.slides.length) return;

      this.querySelector('[data-certificate-previous]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-certificate-next]')?.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.updateActiveDot(), { passive: true });
      this.querySelectorAll('[data-certificate-preview]').forEach((button) => button.addEventListener('click', () => this.openLightbox(button)));
      this.querySelector('[data-certificate-close]')?.addEventListener('click', () => this.lightbox.close());
      this.lightbox?.addEventListener('click', (event) => { if (event.target === this.lightbox) this.lightbox.close(); });
      this.resizeObserver = new ResizeObserver(() => this.buildDots());
      this.resizeObserver.observe(this.track);
      this.buildDots();
    }

    disconnectedCallback() { this.resizeObserver?.disconnect(); }

    step() { return this.slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap || 0); }
    visibleCount() { return Math.max(1, Math.round(this.track.clientWidth / this.step())); }
    pageCount() { return Math.max(1, this.slides.length - this.visibleCount() + 1); }
    move(direction) { this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' }); }
    goTo(index) { this.track.scrollTo({ left: index * this.step(), behavior: 'smooth' }); }

    buildDots() {
      const count = this.pageCount();
      if (this.dots.children.length === count) { this.updateActiveDot(); return; }
      this.dots.replaceChildren();
      for (let index = 0; index < count; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button'; dot.className = 'certificate-slider__dot';
        dot.setAttribute('aria-label', `Show certificate ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dots.append(dot);
      }
      this.updateActiveDot();
    }

    updateActiveDot() {
      const active = Math.min(this.pageCount() - 1, Math.max(0, Math.round(this.track.scrollLeft / this.step())));
      [...this.dots.children].forEach((dot, index) => dot.setAttribute('aria-current', index === active ? 'true' : 'false'));
    }

    openLightbox(button) {
      const image = this.querySelector('[data-certificate-lightbox-image]');
      image.src = button.dataset.fullImage; image.alt = button.dataset.imageAlt || 'RapidTest quality certificate';
      this.lightbox.showModal();
    }
  });
}

